<app-summary-section [stepRoute]="stepRoute()" heading="ZEREZ.ZEREZ">
  @switch (formType()) {
    @case ("PV_2") {
      <app-summary-section-field
        [value]="documentDetails()?.inverterUnitCertificates?.join(', ')"
        label="ZEREZ.INVERTER_UNIT_CERTIFICATE"
      />
      <app-summary-section-field
        [value]="documentDetails()?.powerFlowMonitoringCertificates?.join(', ')"
        label="ZEREZ.POWER_FLOW_MONITORING_CERTIFICATE"
      />
      <app-summary-section-field
        [value]="documentDetails()?.naProtectionCertificates?.join(', ')"
        label="ZEREZ.NA_PROTECTION_CERTIFICATE"
      />
    }
    @case ("STORAGE_2") {
      <app-summary-section-field
        [value]="documentDetails()?.unitCertificates?.join(', ')"
        label="ZEREZ.UNIT_CERTIFICATE"
      />
    }
    @case ("OTHER_2") {
      <app-summary-section-field
        [value]="documentDetails()?.unitOrComponentCertificates?.join(', ')"
        label="ZEREZ.UNIT_OR_COMPONENT_CERTIFICATE"
      />
    }
  }
</app-summary-section>
